import React, { useState, useEffect } from 'react';
import siteInfo from '../siteInfo';
import '../style/install.css';

function isMobile() {
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
    || window.matchMedia('(max-width: 768px)').matches;
}
function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}
function isIOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent) && !window.MSStream;
}

function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    try { if (localStorage.getItem('bb-install-dismissed')) return undefined; } catch (e) { /* ignore */ }
    // Uniquement sur téléphone, et si l'app n'est pas déjà installée.
    if (!isMobile() || isStandalone()) return undefined;

    if (isIOS()) {
      // iOS ne déclenche pas beforeinstallprompt : on montre la marche à suivre.
      setIos(true);
      setShow(true);
      return undefined;
    }

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener('beforeinstallprompt', onPrompt);
    return () => window.removeEventListener('beforeinstallprompt', onPrompt);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch (e) { /* ignore */ }
    setDeferred(null);
    setShow(false);
  };

  const dismiss = () => {
    try { localStorage.setItem('bb-install-dismissed', '1'); } catch (e) { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="bb-install" role="dialog" aria-label="Installer l'application">
      <img className="bb-install__logo" src={`${process.env.PUBLIC_URL}/logo.png`} alt="" />
      <div className="bb-install__text">
        {ios ? (
          <>Installe <b>{siteInfo.name}</b> : appuie sur <b>Partager</b> puis <b>« Sur l'écran d'accueil »</b>.</>
        ) : (
          <>Installe <b>{siteInfo.name}</b> sur ton téléphone, comme une appli.</>
        )}
      </div>
      {!ios && (
        <button type="button" className="bb-btn bb-btn--primary" onClick={install}>Installer</button>
      )}
      <button type="button" className="bb-install__close" onClick={dismiss} aria-label="Fermer">✕</button>
    </div>
  );
}

export default InstallPrompt;
